module.exports = __webpack_public_path__ + "static/media/u31_3.e06a6360.mp3";